import { useMutation } from '@tanstack/react-query';
import type { JobChangeProcessPatchResponse, PostRequest } from '../types/JobChangeProcess';

export default function usePostJobChangeProcess() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({ jobChangeProcessId, status, interviewed_at, profit }: PostRequest) => {
      const response = await fetch(`/agent/api/job_change_processes/${jobChangeProcessId}/logs`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        // profitが存在する場合のみリクエストボディに含める
        body: JSON.stringify({ status, interviewed_at, ...(profit ? { profit } : {}) }),
      });
      const data: JobChangeProcessPatchResponse = await response.json();
      return data;
    },
  });
}
